import { render, staticRenderFns } from "./Usergroup.vue?vue&type=template&id=f279d310&"
import script from "./Usergroup.vue?vue&type=script&lang=js&"
export * from "./Usergroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports